import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
@Component({
  selector: 'app-line-other-income',
  templateUrl: './line-other-income.component.html',
  styleUrls: ['./line-other-income.component.scss']
})
export class LineOtherIncomeComponent implements OnInit {
  @Input() qID: number = null;
  @Input() public type: string[];
  @Input() public titles: string[];
  @Input() public needSources: boolean;
  @Input() public index: number;
  @Input() public income: FormGroup;
  @Output() public removed: EventEmitter<number> = new EventEmitter<number>();
  @Input() public displayErrors: boolean;
  @Input() public ph: string[];
  @Input() public displayX: boolean;


  defaultValue = "";

  
  
  constructor() { }

  ngOnInit() {
	
  }

  static buildIncome(val: any) {
    return new FormGroup({
    type: new FormControl(val[0]? val[0].answerValue : ""),
    amount: new FormControl(val[1]? val[1].answerValue : 0),
    source: new FormControl(val[2]? val[2].answerValue : "")
	});
}
  
}



// WEBPACK FOOTER //
// ./src/app/line-other-income/line-other-income.component.ts